import { useId } from "react";
import { useTranslation } from "react-i18next";

const SMILEY_COUNT = 5;

type Params = {
    maxValue: number;
    isLocked: boolean;
    isSmiley?: boolean;
};

// Ties a rating to its item sub-title and reads its values in the user's
// language ("3 sur 5", "Très satisfait") instead of MUI's English defaults
const useRatingLabels = ({ maxValue, isLocked, isSmiley = false }: Params) => {
    const { t } = useTranslation();
    const subTitleId = useId();

    const getLabelText = (value: number) => {
        if (isSmiley && Number.isInteger(value) && value >= 1) {
            if (value <= SMILEY_COUNT) {
                return t(`rating.smiley${value}`);
            }
        }

        // "{{value, number}}" in the translation writes 3.5 as "3,5" in French
        return t("rating.outOf", { value, max: maxValue });
    };

    return {
        subTitleId,
        ratingProps: {
            getLabelText,
            emptyLabelText: t("rating.empty"),
            // Read-only, MUI renders an image named after the value: keep it
            ...(isLocked
                ? {}
                : { role: "radiogroup", "aria-labelledby": subTitleId }),
        },
    };
};

export default useRatingLabels;
